const VALIDATION_REGEXES = {
  PASSWORD: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-.]).{6,}$/,
  PHONE_NUMBER: /^\+?[0-9]{3}-?[0-9]{6,12}$/,
}

export default VALIDATION_REGEXES
